import React, {ReactElement} from 'react';
import icon from '@assets/images/medops/cms.png';

const CMSIcon = (props: any): ReactElement => {
  return <img src={icon} {...props} />;
};
export default CMSIcon;
